/** parseCollectionFilters produce a filter object (see example) populated
 * from the given URLSearchParams object. */
export const parseCollectionFilters = (params /* URLSearchParams */) => ({
  // Filters
  from: params.get("from"), // ISO date/time string, or key for `dateTimeProducer` fn
  to: params.get("to"), // ISO date/time string, or key for `dateTimeProducer` fn
  name_cnts: params.get("name_cnts"), // the name of the collection contains this text
  id: params.get("id"), // id matches
  id_cnts: params.get("id_cnts"), // id contains this text
  observation_id: params.get("id"), // observation id matches
  sort_order: params.get("sort_order") || "DESC",
  sort_by: params.get("sort_by") || "updated",
})
